import { useEffect, useState } from "react";
import { getLockerPluginOptions } from '../services/queryParams';
import { Theme } from '../data/DesignTypes';
import '../themes/dark.css';

export const useSystemTheme = () => {
    const getMatchMedia = () => window.matchMedia("(prefers-color-scheme: dark)");

    const [isDarkTheme, setIsDarkTheme] = useState(getMatchMedia().matches);

    const themeListener = (e: any) => {
        setIsDarkTheme(e.matches);
    }

    useEffect(() => {
        const theme = getMatchMedia();
        theme.addEventListener('change', (e: any) => {
            themeListener(e);
        })
    }, []);

    return isDarkTheme ? Theme.dark : Theme.light;
}

export function useTheme(): void {
    const options = getLockerPluginOptions();
    const systemTheme = useSystemTheme();

    const theme: Theme = options?.theme && Object.keys(Theme).includes(options?.theme) ? options.theme as Theme : systemTheme;
    const bodyEl = document.querySelector('body');
    if (theme == Theme.dark && !bodyEl?.classList.contains(Theme.dark)) {
        bodyEl?.classList.toggle(Theme.dark);
    }
}